import { metrics } from '@atlassian/browser-metrics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PerformanceMetric = any;

export const COLUMN_RESIZED = 'column-resized';
export const COLUMN_VISIBILITY_CHANGED = 'column-visibility-changed';
export const DND_ROW_DROPPED = 'dnd-row-droppped';
export const DND_ROW_LIFTED = 'dnd-row-lifted';
export const MORE_FIELDS_BUTTON_CLICKED = 'more-fields-button-clicked';

export type InteractionMetricType =
	| typeof COLUMN_RESIZED
	| typeof COLUMN_VISIBILITY_CHANGED
	| typeof DND_ROW_DROPPED
	| typeof DND_ROW_LIFTED
	| typeof MORE_FIELDS_BUTTON_CLICKED;

const interactionMetrics = {
	[COLUMN_RESIZED]: metrics.interaction({
		key: `jwm.list.${COLUMN_RESIZED}`,
	}),
	[COLUMN_VISIBILITY_CHANGED]: metrics.interaction({
		key: `jwm.list.${COLUMN_VISIBILITY_CHANGED}`,
	}),
	[MORE_FIELDS_BUTTON_CLICKED]: metrics.interaction({
		key: `jwm.list.${MORE_FIELDS_BUTTON_CLICKED}`,
	}),
	[DND_ROW_LIFTED]: metrics.interaction({
		key: `jwm.list.${DND_ROW_LIFTED}`,
	}),
	[DND_ROW_DROPPED]: metrics.interaction({
		key: `jwm.list.${DND_ROW_DROPPED}`,
	}),
} as const;

export const useInteractionMetrics = (): Record<InteractionMetricType, PerformanceMetric> =>
	interactionMetrics;
